/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/flag.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { SevenDaySumTable } from 'components/sevenDaySumTable'
import { Link } from '@ta-interaktiv/contentbricks'
// TODO Set the correct article ID here
const ARTICLE_ID = '549542025354'

const data = require('../../currentData.json')

export function AppComponent() {
  console.log('____', data)
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>
              In welchen Ländern die Fälle zurzeit besonders schnell steigen
            </h1>
            <h2>
              Eine Übersicht zeigt, welche Staaten jene mit den verhältnismässig
              meisten neuen Covid-Fällen sind – und mit den lockersten
              Schutzmassnahmen.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              <span>Marc Brupbacher</span>, <span>Sebastian Broschinski</span>
            </div>
            <div className='ta updated'>Aktualisiert am 17. November 2020</div>
          </div>
          <div className='ta text'>
            <p>
              Die nachfolgende Visualisierung zeigt, in welchen Ländern der
              Anstieg an neuen bestätigten Covid-19-Fällen besonders gross war
              in den letzten Tagen und Wochen. Die Schweiz verzeichnete in den
              vergangenen 7 Tagen 18’559 neue Corona-Fälle. Das sind 118 Prozent
              mehr als in der Woche davor. Das bedeutet für den Moment beim
              Tempo des Wachstums an bestätigten Neuinfektionen fast Weltspitze.
            </p>
            <p>
              Weiter ist aufgelistet, wie stark die Massnahmen gegen Sars-CoV-2
              sind, welche in den Ländern in Kraft sind. Die{' '}
              <Link href='https://www.bsg.ox.ac.uk/research/research-projects/coronavirus-government-response-tracker'>
                Universität Oxford
              </Link>{' '}
              zeigt anhand von 17 Indikatoren, wie rigoros die Staaten zurzeit
              gegen die Epidemie im eigenen Land vorgehen. Das Maximum des
              Indexwertes beträgt 100 Punkte, das bedeutet sehr strenge
              Eindämmungsmassnahmen. Wenn ein Land unter 70 Punkte fällt, wird
              das von der Universität als «lockere Reaktion» auf das Virus
              bewertet. Die Schweiz fiel nach der Turboöffnung des Bundesrates
              im Frühsommer von 77 Punkten auf 31 Punkte und lag letzte Woche
              bei knapp 60 Punkten. Damit gehörte sie in Europa zu den Ländern
              mit den laxesten Massnahmen. Gestern hat nun jedoch der{' '}
              <Link allowWordWrap href='297674823833'>
                Bundesrat die Schraube wieder angezogen
              </Link>
              , die neuen Regeln widerspiegeln sich im Indexwert noch nicht.
            </p>
            <p>
              Doch wird das genügen, um den gegenwärtig schnellsten Anstieg an
              Neuinfektionen in Europa zu bremsen? Ein Blick in den
              Massnahmenkatalog der anderen Länder, die eine ähnlich steile
              Kurve haben,{' '}
              <Link allowWordWrap href='443842599586'>
                stimmt einen skeptisch
              </Link>
              .
            </p>
            <p>
              So gehen Belgien, Tschechien und die Niederlande um einiges weiter
              als die Schweiz.
            </p>

            <ul>
              <li>
                In <b>Belgien</b> müssen wegen der drastisch gestiegenen
                Corona-Infektionszahlen alle  Bars und Restaurants für vier Wochen
                schliessen. Zudem soll es täglich von Mitternacht bis 5 Uhr
                morgens landesweit eine Ausgangssperre geben. Die Bürger sind
                ausserdem angehalten, wenn möglich im Homeoffice zu arbeiten und
                nur noch mit einer Person ausserhalb des eigenen Haushalts einen
                engeren Kontakt zu pflegen. Auch der Alkoholverkauf nach 20 Uhr
                wird verboten, und Weihnachtsmärkte werden abgesagt.
              </li>
              <li>
                In <b>Tschechien</b> hat die Regierung beschlossen, dass
                Restaurants, Bars und Clubs ab Mittwoch geschlossen bleiben
                müssen. Die Schulen gehen bis Anfang November zum Fernunterricht
                über. Versammlungen und Treffen mit mehr als sechs Menschen
                werden untersagt. Mittlerweile wird selbst ein zweiter harter
                Lockdown mit Ausgangsbeschränkungen nicht mehr gänzlich
                ausgeschlossen. Die Entscheidung könnte Anfang November fallen.
              </li>
              <li>
                Die <b>Niederlande</b> haben die Corona-Massnahmen drastisch
                verschärft. Kneipen, Cafés und Restaurants werden in diesem
                «Teil-Lockdown» geschlossen, und der Verkauf von Alkohol wird ab
                20 Uhr verboten. Ausserdem dürfen die Bürger nur noch maximal
                drei Gäste pro Tag in ihren Wohnungen empfangen und sollen Bus
                und Bahn nur noch in dringenden Fällen nutzen. Premier Mark
                Rutte kündigte auch eine allgemeine Maskenpflicht an für alle
                öffentlichen Räume wie Geschäfte, Museen oder Bibliotheken,
                bisher war dies nur eine dringende Empfehlung.
              </li>
            </ul>
          </div>
        </div>
        <div className='ui  container'>
          <SevenDaySumTable data={data} />
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie verständlich war die Tabelle?'
        ]}
        credits={[
          ['Konzept und Umsetzung', 'Marc Brupbacher, Sebastian Broschinski'],
          [
            'Quellen',
            'Hale, Thomas, Sam Webster, Anna Petherick, Toby Phillips und Beatriz Kira (2020). Oxford COVID-19 Government Response Tracker, Blavatnik School of Government. <br/><br/>Johns Hopkins University, basierend auf Daten von WHO, verschiedenen nationalen Gesundheitsbehörden und Agenturen <br/><br/>Kantone und BAG'
          ]
        ]}
      />
    </div>
  )
}
